var CashierScreenTypes = /* @__PURE__ */ ((CashierScreenTypes2) => {
  CashierScreenTypes2["base"] = "base";
  CashierScreenTypes2["sucess"] = "sucess";
  CashierScreenTypes2["fail"] = "fail";
  return CashierScreenTypes2;
})(CashierScreenTypes || {});
var SmarticoActions = /* @__PURE__ */ ((SmarticoActions2) => {
  SmarticoActions2["CashierClosureAfterRegNoDep"] = "CashierClosureAfterRegNoDep";
  SmarticoActions2["CashierClosureAfterRegHasDep"] = "CashierClosureAfterRegHasDep";
  SmarticoActions2["CashierClosureAfterRegFailedDep"] = "CashierClosureAfterRegFailedDep";
  return SmarticoActions2;
})(SmarticoActions || {});
const smarticoActionsForCashierScreen = {
  [
    "base"
    /* base */
  ]: "CashierClosureAfterRegNoDep",
  [
    "sucess"
    /* sucess */
  ]: "CashierClosureAfterRegHasDep",
  [
    "fail"
    /* fail */
  ]: "CashierClosureAfterRegFailedDep"
  /* CashierClosureAfterRegFailedDep */
};
var CustomerGenders = /* @__PURE__ */ ((CustomerGenders2) => {
  CustomerGenders2[CustomerGenders2["male"] = 1] = "male";
  CustomerGenders2[CustomerGenders2["female"] = 2] = "female";
  CustomerGenders2[CustomerGenders2["other"] = 3] = "other";
  return CustomerGenders2;
})(CustomerGenders || {});
var CustomerFinalizeRegStep = /* @__PURE__ */ ((CustomerFinalizeRegStep2) => {
  CustomerFinalizeRegStep2["ibanLimits"] = "iban-limits";
  return CustomerFinalizeRegStep2;
})(CustomerFinalizeRegStep || {});
var DisabledStatus = /* @__PURE__ */ ((DisabledStatus2) => {
  DisabledStatus2[DisabledStatus2["block_id_upload"] = 5] = "block_id_upload";
  return DisabledStatus2;
})(DisabledStatus || {});
var BonusRegistrationTypes = /* @__PURE__ */ ((BonusRegistrationTypes2) => {
  BonusRegistrationTypes2[BonusRegistrationTypes2["NONE"] = 0] = "NONE";
  BonusRegistrationTypes2[BonusRegistrationTypes2["SPORT"] = 1] = "SPORT";
  BonusRegistrationTypes2[BonusRegistrationTypes2["CASINO"] = 2] = "CASINO";
  BonusRegistrationTypes2[BonusRegistrationTypes2["CasinoAdditional"] = 3] = "CasinoAdditional";
  BonusRegistrationTypes2["noBonusCustom"] = "noBonusCustom";
  return BonusRegistrationTypes2;
})(BonusRegistrationTypes || {});
var IdentityDocumentTypes = /* @__PURE__ */ ((IdentityDocumentTypes2) => {
  IdentityDocumentTypes2[IdentityDocumentTypes2["passport"] = 1] = "passport";
  IdentityDocumentTypes2[IdentityDocumentTypes2["idCard"] = 2] = "idCard";
  IdentityDocumentTypes2[IdentityDocumentTypes2["driversLicence"] = 3] = "driversLicence";
  return IdentityDocumentTypes2;
})(IdentityDocumentTypes || {});
export {
  BonusRegistrationTypes,
  CashierScreenTypes,
  CustomerFinalizeRegStep,
  CustomerGenders,
  DisabledStatus,
  IdentityDocumentTypes,
  SmarticoActions,
  smarticoActionsForCashierScreen
};
